import clsx from 'clsx';
import React from 'react';
import Button from '../Button';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import { useButtonSizeLarge } from '../../utils/buttonSizes';
import { OrganizationPaymentMethodEnum } from '@EHSNavigator/backend';
import { useLocalStorage } from '@uidotdev/usehooks';
import { UserWithOrgContext } from '../../types/user';

interface BulkUserUploadConfirmationModalProps {
  otherClasses?: string;
  formHandler: any,
  handleClose: () => void
}

const BulkUserUploadConfirmationModal: React.FC<BulkUserUploadConfirmationModalProps> = ({
  otherClasses,
  formHandler,
  handleClose
}) => {
  const bulkUserUploadConfirmationModalClasses = clsx(otherClasses);
  const lg = useButtonSizeLarge();
  const [userInfo] = useLocalStorage<UserWithOrgContext | null>('userInfo', null);
  const isManualPaymentMethod = (userInfo?.user.org.paymentMethod === OrganizationPaymentMethodEnum.Manual || userInfo?.orgContext?.org?.paymentMethod === OrganizationPaymentMethodEnum.Manual);

  return (
    <div className={bulkUserUploadConfirmationModalClasses} data-testid="bulk-user-upload-confirmation-modal">
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <WarningIcon className="[&>g>path]:fill-brand-byzantine h-12 w-12 md:h-85 md:w-85" />
        <p className="text-brand-byzantine text-lg leading-5 font-normal">
          {!isManualPaymentMethod ? (
            <>
              Each user costs <strong>$25 per month</strong>, and a yearly fee of{" "}
              <strong>$300 will be automatically charged</strong> for each user.
            </>
          ) : (
            <>
              Each user costs <strong>$25 per month</strong>. Billing will be handled
              manually by the platform administrator.
            </>
          )}
          <br />
          <br />
          Are you sure you want to continue?
        </p>
      </div>
      <div className="mt-8 flex flex-col-reverse gap-2.5 sm:grid sm:grid-cols-2 sm:gap-6 lg:mt-12">
        <Button
          otherClasses="!text-brand-byzantine hover:text-brand-byzantine hover:border-brand-byzantine "
          size={lg}
          variant="secondary"
          disable={formHandler?.isSubmitting}
          onClick={() => handleClose()}
        >
          Cancel
        </Button>
        <Button
          disable={formHandler?.isSubmitting}
          loading={formHandler?.isSubmitting}
          otherClasses="bg-brand-byzantine hover:text-brand-byzantine hover:bg-transparent hover:border-brand-byzantine"
          size={lg}
          onClick={() => formHandler?.handleSubmit()}
        >
          Upload now
        </Button>
      </div>
    </div>
  );
};

export default BulkUserUploadConfirmationModal;
